<script setup>
import {onMounted, ref, watch, defineProps, defineEmits} from "vue";
import useSharedData from "@/use/SharedData.js";
import axios from "axios";

const props = defineProps({
    value: [Number, Array],
    readonly: Boolean,
    disabled: Boolean,
    label: String,
    rules: Array,
    multiple: Boolean,
});

const emit = defineEmits(["input", "change"]);

const {loading, inputColor, backgroundColor} = useSharedData();

const offset = ref(null);
const offsets = ref([]);

function findAll() {
    loading.value  = true;
    axios.get(`/reports/getYearOffsets`).then(response => {
        offsets.value  = response.data;
    }).finally(() => {
        loading.value = false;
    });
}

function input(value) {
    emit('input', value)
}

function change() {
    emit('change')
}

watch(() => props.value, () => {
    offset.value = props.value;
}, {immediate: true});

onMounted(() => findAll());
</script>

<template>
    <div>
        <v-autocomplete
            v-model="offset"
            :items="offsets"
            item-value="offset"
            item-text="year"
            outlined
            dense
            :label="label"
            :color="inputColor"
            :background-color="backgroundColor"
            :readonly="readonly"
            :disabled="disabled"
            :multiple="multiple"
            :loading="loading"
            :clearable="!readonly"
            @input="input"
            @change="change"
            :rules="rules"
            hide-details="auto"
        ></v-autocomplete>

        <input type="hidden">
    </div>
</template>